import axios from 'plugins/axios'

export const state = {
  list: null
}

export const getters = {
  get: (state) => {
    if (!state.list) return {}
    return state.list
  }
}

export const mutations = {
  set (state, paymentMethods) {
    state.list = paymentMethods
  }
}

export const actions = {
  async request ({state, commit}) {
    if (state.list) return

    let {data} = await axios.get(`/shops/payment-methods?id=${Math.random() * 10}`)
    commit('set', data.data)
  }
}



// WEBPACK FOOTER //
// ./client/store/paymentMethods.js